import { action, computed, thunk, thunkOn } from "easy-peasy";
import {
  makeAuthorizedPostRequestToBackend,
  makeUrl,
} from "../helpers/backendApi";
import _ from "lodash";
import { onLogoutResolver } from "./on-logout-resolver";

export const hashFlopption = (row) => row["flopption_id"];

function addMissingColumns(row) {
  if (
    _.isUndefined(row["group#-tour#"]) &&
    !_.isUndefined(row["[Book] Group#"]) &&
    !_.isUndefined(row["[Book] Tour#"])
  ) {
    row["group#-tour#"] = row["[Book] Group#"] + "-" + row["[Book] Tour#"];
  }
  if (_.isUndefined(row["num_passengers"])) {
    row["num_passengers"] = row["[Book] Total"] || row["Est Cnt"];
  }
  if (_.isUndefined(row["Act Cnt"])) {
    row["Act Cnt"] = row["[Book] Total"];
  }
  return row;
}

function floor0(v) {
  return v < 0 ? 0 : v;
}

function reviseSavings(actionReport) {
  const ogFare = actionReport.fare;
  const ogNumPassengers = actionReport["num_passengers"];

  const bookedFare = actionReport.price;
  const bookedTickets = actionReport.numTickets;
  const currentAvgFare = actionReport["Current Avg Fare"];
  const targetFare = actionReport["Target Fare"];
  const baselineFare = currentAvgFare || targetFare;

  const realizedBaselineFareSavings = baselineFare - bookedFare;
  const realizedBaselineFareSavingsPct =
    (100 * realizedBaselineFareSavings) / baselineFare;
  const realizedBaselineTotalSavings =
    realizedBaselineFareSavings * bookedTickets;

  const realizedTargetFareSavings = targetFare - bookedFare;
  const realizedTargetFareSavingsPct =
    (100 * realizedTargetFareSavings) / targetFare;
  const realizedTargetTotalSavings = realizedTargetFareSavings * bookedTickets;

  const realizedCurrentAvgFareSavings = currentAvgFare - bookedFare;
  const realizedCurrentAvgFareSavingsPct =
    (100 * realizedCurrentAvgFareSavings) / currentAvgFare;
  const realizedCurrentAvgTotalSavings =
    realizedCurrentAvgFareSavings * bookedTickets;

  const ogCurrentAvgFareSavings = currentAvgFare - ogFare;
  const ogCurrentAvgFareSavingsPct =
    (100 * ogCurrentAvgFareSavings) / currentAvgFare;
  const ogCurrentAvgTotalSavings = ogCurrentAvgFareSavings * ogNumPassengers;

  return {
    ...actionReport,
    "[Calc] Baseline Fare": baselineFare,
    "[Calc] Baseline Savings": floor0(realizedBaselineFareSavings),
    "[Calc] Baseline Total Savings": floor0(realizedBaselineTotalSavings),
    "[Calc] Baseline % Savings": floor0(realizedBaselineFareSavingsPct),
    "[Calc] Target Savings": floor0(realizedTargetFareSavings),
    "[Calc] Target Total Savings": floor0(realizedTargetTotalSavings),
    "[Calc] Target % Savings": floor0(realizedTargetFareSavingsPct),
    "[Calc] Current Avg Savings": floor0(realizedCurrentAvgFareSavings),
    "[Calc] Current Avg Total Savings": floor0(realizedCurrentAvgTotalSavings),
    "[Calc] Current Avg % Savings": floor0(realizedCurrentAvgFareSavingsPct),
    "[O] Current Avg Savings": floor0(ogCurrentAvgFareSavings),
    "[O] Current Avg Total Savings": floor0(ogCurrentAvgTotalSavings),
    "[O] Current Avg % Savings": floor0(ogCurrentAvgFareSavingsPct),
  };
}

function concatReasons(reasons) {
  return _.sortBy(reasons, "codeName").map(({ codeName }) => codeName);
  // .join(",");
}

const modelActionReports = {
  INITIAL_DATA_ENDPOINT: "action_reports",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: true,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: true,
  NAME: "actionReports",
  initialData: [],
  initialDataReceived: false,
  initialDataLoading: false,
  additionalData: [],
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = [];
    state.initialDataReceived = false;
    state.initialDataLoading = false;
    state.additionalData = [];
  }),
  onLogout: thunkOn(onLogoutResolver, (actions) => {
    actions.resetData();
  }),
  receiveInitialData: action((state, payload) => {
    state.initialData = [...payload]
      .map(
        ({
          id,
          action,
          submitted_by,
          submitted_at,
          payload,
          snapshot,
          ...rest
        }) => ({
          ...rest,
          ...snapshot,
          ...payload,
          id,
          action,
          submitted_by,
          submitted_at,
        })
      )
      .map(reviseSavings)
      .map(addMissingColumns);
  }),
  bookingsRowData: computed((state) =>
    state.initialData
      .filter(({ action }) => action === "booked")
      .filter(
        ({ submitted_by }) => submitted_by !== "c-amrit.saxena@worldstrides.org"
      )
  ),
  skippingsRowData: computed((state) =>
    state.initialData
      .filter(({ action }) => action === "skipping")

      .map(({ reasons, ...rest }) => ({
        reasons: concatReasons(reasons),
        ...rest,
      }))
  ),
  suspendsRowData: computed((state) =>
    _.uniqBy(state.initialData, hashFlopption).filter(
      ({ action }) => action === "suspend"
    )
  ),
  handleSubmitActionReport: thunk(async (actions, actionReport) => {
    const url = makeUrl({ endpoint: "action_reports" }); // NOTE: appMode not necessary here :)
    await makeAuthorizedPostRequestToBackend({
      url,
      data: actionReport,
      axiosConfig: undefined,
    });
    actions.handleFetchInitialData();
  }),
};

export default modelActionReports;
